import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import InputMask from 'react-input-mask';
import { Utils } from '../../utils/utils';
import './esqueci-minha-senha.css';

import {
  Footer
} from '../../components';

export default class ViewEsqueciMinhaSenha extends Component {
  constructor(props) {
    super(props);

    this.cpfRef = React.createRef();

    this.state = {
      "render_preloader": false,
      "render_success": false,
      "render_error": false,
      "field_cpf": ""
    }
  }

  componentDidMount() {
  }

  async recuperarSenha() {
    var _this = this;
    _this.setState({
      "render_preloader": true,
      "render_error": false
    });

    // Utils.mobileHapticFeeback();

    var cpf = this.state.field_cpf.replaceAll(".", "").replaceAll("-", "");

    try {
      const context = await (await fetch('./api_context.json')).json();
      console.log(context);
      await Sdk.Api.authorization.signinByProjectAnonymous(context.project_uid)
      await Sdk.Api.dynamic.bridge(`auth/v1.1/user/password/forgot?login=${cpf}`, {}, 'POST');
      // await window.fetch(`https://api.digitalpages.com.br/auth/v1.1/user/password/forgot?login=${cpf}`, {
      //   method: 'GET',
      //   headers: {
      //     "Api-Env": "production",
      //     "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479"
      //   }
      // });
      
      _this.setState({
        "render_success": true,
        "render_preloader": false
      });
    } catch (e) {
      _this.setState({
        "render_error": true,
        "render_preloader": false
      });

      // Utils.mobileVibrate();
    }
  }

  onChangeCpf(val) {
    this.setState({
      "field_cpf": val.replaceAll(".", "").replaceAll("-", "")
    });
  }

  isValidCpf(cpf) {
    cpf = cpf.replace(/[^\d]/g, '');
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    
    let sum = 0;
    for (let i = 0; i < 9; i++) sum += parseInt(cpf[i]) * (10 - i);
    let digit1 = (sum * 10) % 11;
    if (digit1 === 10) digit1 = 0;
    if (digit1 !== parseInt(cpf[9])) return false;
    
    sum = 0;
    for (let i = 0; i < 10; i++) sum += parseInt(cpf[i]) * (11 - i);
    let digit2 = (sum * 10) % 11;
    if (digit2 === 10) digit2 = 0;
    return digit2 === parseInt(cpf[10]);
  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  render() {
    const {
      render_preloader,
      render_success,
      render_error
    } = this.state;

    return <div className="rdp-react-template-view-esqueci-minha-senha">
      <div className="rdp-react-template-view-esqueci-minha-senha-header">
        <span className="rdp-react-template-view-esqueci-minha-senha-header-logo"></span>
      </div>
      {render_preloader &&
        <div className="rdp-react-template-view-esqueci-minha-senha-preloader">
          <div className="rdp-react-template-view-esqueci-minha-senha-preloader-loader"></div>
        </div>
      }

      {render_error &&
        <div className="rdp-react-template-view-esqueci-minha-senha-error">
          <div className="rdp-react-template-view-esqueci-minha-senha-error-box">
            <span className="rdp-react-template-view-esqueci-minha-senha-error-box-icon"></span>
            <h1 className="rdp-react-template-view-esqueci-minha-senha-error-box-title">CPF não encontrado!</h1>
            <p className="rdp-react-template-view-esqueci-minha-senha-error-box-message">
              Verifique se o CPF está correto e <br></br>tente novamente.
            </p>
            <button className="rdp-component-btn primary position-left icon-left" onClick={() => this.setState({"render_error": false})}>Voltar</button>
          </div>
        </div>
      }

      <div className="rdp-react-template-view-esqueci-minha-senha-content">
        {render_success ? (
          <>
            <span className="rdp-react-template-view-esqueci-minha-senha-title">
              E-mail enviado com sucesso!
            </span>
            <p className="rdp-react-template-view-esqueci-minha-senha-message">
              Verifique sua caixa de entrada e siga as instruções para redefinir sua senha. Clique no link recebido por e-mail para criar sua nova senha.
            </p>
            <button className="rdp-component-btn primary position-left" onClick={() => this.redirectTo("/login")}>
              Voltar ao Login
            </button>
          </>
        ) : (
          <>
            <span className="rdp-react-template-view-esqueci-minha-senha-title">
              Esqueci minha senha
            </span>


            <InputMask
              className="rdp-react-template-view-esqueci-minha-senha-input"
              mask="999.999.999-99"
              type="text"
              placeholder="Digite seu CPF"
              ref={this.cpfRef}
              value={this.state.field_cpf}
              onChange={(e) => this.onChangeCpf(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  this.recuperarSenha();
                }
              }}
            />

            <div className="rdp-component-btn-group-flex">
              <button className="rdp-component-btn secondary position-left icon-left" onClick={() => this.redirectTo("/login")}>Voltar</button>
              <button 
                className={`rdp-component-btn primary position-right icon-right ${!this.isValidCpf(this.state.field_cpf) ? "inactive" : ""}`} 
                onClick={() => this.recuperarSenha()}
                disabled={!this.isValidCpf(this.state.field_cpf)}
              >
                {render_preloader ? "Aguarde..." : "Recuperar"}
              </button>
            </div>
          </>
        )}
      </div>

      <Footer style={{ width: '100%' }} />
    </div>;
  }
}